/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from 'prop-types'

import InputSingleline from '../InputSingleline'

const propTypes = {
    rows: PropTypes.number,
    data: PropTypes.shape({
        value: PropTypes.string,
    }),
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
}

const defaultProps = {
    rows: 4,
    data: {},
    minRows: 4,
    maxRows: undefined,
}

const InputMultiline = (props) => {
    const {
        rows,
        minRows,
        data: {
            value,
        },
    } = props

    const countValueRowNumber = value?.split(/\r\n|\r|\n/).length

    return (
        <InputSingleline
            {...props}
            minRows={minRows}
            rows={minRows ? undefined : (countValueRowNumber || rows)}
            multiline
        />
    )
}

InputMultiline.propTypes = propTypes
InputMultiline.defaultProps = defaultProps

export default InputMultiline
